import React, { useEffect } from 'react';
import ResultComponent from '../components/Result';
import { eventTracking } from '../../Module/marketing';

// interface MatchParams {
//     value: string;
// }

const MbtiResult = ({ match }) => {
    const answer = Number(match.params.value) //결과값 설정

    useEffect(() => {
        eventTracking.SetGoogleAnalytics();
        eventTracking.SetKakaoPixel();
    }, [])

    return (
        <div className="mbti-wrapper">
            <h1 className="hidden-obj">MBTI</h1>
            <ResultComponent resultValue={answer} />
        </div >
    )
}

export default MbtiResult;